import Modal from 'bootstrap/js/dist/modal';

($ => {
	const disclaimerModal = document.getElementById('disclaimer-modal');

	if (disclaimerModal) {
		$(document).ready(function() {
			const disclaimerModalInstance = new Modal(disclaimerModal, {
				backdrop: 'static',
				keyboard: false,
			});

			// Check if disclaimer cookie exists
			const hasApprovedDisclaimer = document.cookie.split('; ').some(row => row.startsWith('disclaimer_approved=true'));

			if (!hasApprovedDisclaimer) {
				disclaimerModalInstance.show();
			}

			$(document).on('click', '#disclaimer-accept-btn', function(e) {
				e.preventDefault();

				$.ajax({
					url: window.ajax_object.ajax_url,
					type: 'POST',
					data: {
						action: 'set_disclaimer_cookie',
						approved: true,
						nonce: window.ajax_object.nonce,
					},
					success(response) {
						if (response.success) {
							disclaimerModalInstance.hide();
							document.cookie = 'disclaimer_approved=true;path=/;max-age=' + 3600;

							if (response.data && response.data.redirect_page) {
								window.location.href = response.data.redirect_page;
							}
						} else {
							console.error('Failed to set cookie:', response.data);
						}
					},
					error(xhr, status, error) {
						console.error('Ajax error:', error);
						console.error('Status:', status);
						console.error('Response:', xhr.responseText);
					},
				});
			});

			const redirectionUrl = $('#disclaimer-decline-btn').data('redirection');

			$(document).on('click', '#disclaimer-decline-btn', function(e) {
				e.preventDefault();
				$.ajax({
					url: window.ajax_object.ajax_url,
					type: 'POST',
					data: {
						action: 'set_disclaimer_cookie',
						approved: false,
						nonce: window.ajax_object.nonce,
					},
					complete() {
						document.cookie = 'disclaimer_approved=false;path=/;max-age=' + 3600;
						window.location.href = redirectionUrl;
					},
				});
			});
		});
	}
})(window.jQuery);
